import { translation, format, TranslatedComponent } from '@hh.ru/front-static-app';
import { Card, Title, useBreakpoint } from '@hh.ru/magritte-ui';

import { useCalculatorContext } from 'src/pages/Profession/components/SectionCalculator/Context';

import CalculatorFillSkillsDialog from 'src/pages/Profession/components/SectionCalculator/Calculator/CalculatorFillSkillsDialog';
import CalculatorFillSkillsToggle from 'src/pages/Profession/components/SectionCalculator/Calculator/CalculatorFillSkillsToggle';
import CalculatorLoginDialog from 'src/pages/Profession/components/SectionCalculator/Calculator/CalculatorLoginDialog';
import CalculatorSkills from 'src/pages/Profession/components/SectionCalculator/Calculator/CalculatorSkills';
import CalculatorTablo from 'src/pages/Profession/components/SectionCalculator/Calculator/CalculatorTablo';

import styles from './styles.less';

const TrlKeys = {
    title: 'career-platform.profession.sections.calculator.title',
    description: 'career-platform.profession.sections.calculator.description',
};

const Calculator: TranslatedComponent = ({ trls }) => {
    const { gradeName } = useCalculatorContext();
    const { isXS, isS } = useBreakpoint();
    const isMobile = isXS || isS;

    return (
        <Card
            padding={isMobile ? 16 : 24}
            borderRadius={isMobile ? 16 : 32}
            borderBottomLeftRadius={isMobile ? 24 : 32}
            borderBottomRightRadius={isMobile ? 24 : 32}
            showBorder
            stretched
        >
            <div className={styles.content}>
                <header>
                    <Title
                        size={isMobile ? 'small' : 'medium'}
                        description={trls[TrlKeys.description]}
                        Element="h2"
                        dataQaTitle="calculator-title"
                    >
                        {format(trls[TrlKeys.title], {
                            '{0}': gradeName.toLowerCase(),
                        })}
                    </Title>
                </header>
                <CalculatorTablo />
                <CalculatorFillSkillsToggle />
                <CalculatorSkills />
                <CalculatorLoginDialog />
                <CalculatorFillSkillsDialog />
            </div>
        </Card>
    );
};

export default translation(Calculator);
